import React,{useState,useEffect,useRef} from "react"
import { useGlobalContext } from "../../context/provider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars,faUser } from "@fortawesome/free-solid-svg-icons";

import LogoLight from '@/public/EVElogo.webp'
import LogoDark from '@/public/EVElogoWhite.webp'
import Image from "next/image";
import UserMenu from "../../HeaderMenu/UserMenu";
import MobileHeaderMenu from "../../HeaderMenu/MoblieHeaderMenu";
import '@/antd.setup'
import { useRouter } from "next/navigation";
import { AxiosGetData } from "../../context/axiosfunction";
import NotiDesktop from "../Noti/NotiDesktop";
import NotiMobile from "../Noti/NotiMobile";
import Link from "next/link";

const HeaderMobile = ({noti, hasFreeCampaigns = false}) => {
    const { theme, CartAction, Token, Noti_length, API, headers, privateKey, DataUser } = useGlobalContext();
    const [menu, setMenu] = useState(false);
    const [mainMenu,setMainMenu]=useState(false);
    const wrapperRef = useRef(null);
    const MainMenu = useRef(null);
    const router = useRouter()
    const [notidrawer,setNotiDrawer] = useState(false)
    const [notidata,setNotidata] = useState(null)

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          setMenu(false);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (MainMenu.current && !MainMenu.current.contains(event.target)) {
          setMainMenu(false);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

    // const GetNoti = async() => {
    //   const getNotidata = await AxiosGetData(API,'/api/checkauthent/get_noti',headers,privateKey)
    // }
  
    return (
      <>
        <div style={{ zIndex: 500 }} className="w-full h-[70px] bg-web fixed top-0 left-0 right-0" />
  
        <div style={{ zIndex: 700 }} className="flex px-[7%] items-center justify-between w-full h-[70px] fixed top-0 left-0 right-0">
          <div ref={MainMenu} className="flex items-center gap-[1em]" >
            <button onClick={() => setMainMenu((prev) => !prev)} className="w-[35px] sm:w-[48px] cursor-pointer rounded-full page-surface h-[35px] sm:h-[48px] flex items-center justify-center">
              <FontAwesomeIcon icon={faBars} />
            </button>

            <MobileHeaderMenu menu={mainMenu} setMenu={setMainMenu} hasFreeCampaigns={hasFreeCampaigns} />
            <button onClick={()=>router.push('/cart')} className="w-[35px] sm:w-[48px] cursor-pointer rounded-full page-surface h-[35px] sm:h-[48px] flex items-center justify-center relative" >
                {theme==='light_theme' ?                         
                  <img className="w-auto sm:h-[24px] h-[21px]" src="https://eve-image.eveebook.com/image.eveebook/web_image/cart.png" alt="cart" /> :
                  <img className="w-auto sm:h-[24px] h-[21px]" src="https://eve-image.eveebook.com/image.eveebook/web_image/cart_w.png" alt="cart" />         
                }
                <div className="absolute top-[-5px] sm:top-0 right-[-7px] sm:right-0">
                  {CartAction&&
                    <>
                    {CartAction.length > 0 &&
                      <div className=" text-[10px] font-bold text-white flex justify-center items-center w-[17px] h-[17px] bg-[#E04C4C] rounded-full">
                        <span>{CartAction.length}</span>
                      </div>
                    }
                    </>  
                  }
                </div>
            </button>
          </div>
         
  
          <Link href="/" prefetch={true} className="cursor-pointer flex items-center">
            <Image
              className="h-[32px] sm:h-[48px] w-auto"
              src={theme === 'light_theme' ? LogoLight : LogoDark}
              width={100}
              height={100}
              alt="logo"
            />
          </Link>
          
          <div ref={wrapperRef} className="flex items-center gap-[1em]">
            {Token &&
              <NotiMobile noti={noti} />
            }
            <button
              onClick={() => setMenu((prev) => !prev)}
              className="w-[35px] sm:w-[48px] cursor-pointer rounded-full page-surface h-[35px] sm:h-[48px] flex items-center justify-center overflow-hidden"
            >
              {DataUser?.imge_profile_ebook ? (
                <div
                  className="w-full h-full rounded-full"
                  style={{
                    backgroundImage: `url(${DataUser?.imge_profile_ebook}?t=${Date.now()})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                />
              ) : (
                <FontAwesomeIcon icon={faUser} />
              )}
            </button>
  
            <UserMenu menu={menu} setMenu={setMenu} />
          </div>
        </div>
      </>
    );
  };

export default HeaderMobile
